const ENV = {
    API_URL: typeof APP_URL !== 'undefined' ? APP_URL : process.env.MIX_HOST,
    DEMO: typeof APP_DEMO !== 'undefined' ? APP_DEMO : process.env.MIX_DEMO,
    API_KEY: typeof APP_KEY !== 'undefined' ? APP_KEY : process.env.MIX_API_KEY,
    SHOW_BRAND_IMAGE: typeof SHOW_BRAND_IMAGE !== 'undefined' ? SHOW_BRAND_IMAGE : process.env.MIX_SHOW_BRAND_IMAGE,
    STORE_OUTLETS_USE: typeof STORE_OUTLETS_USE !== 'undefined' ? STORE_OUTLETS_USE : process.env.MIX_STORE_OUTLETS_USE,
    LOADER_COLOR: typeof LOADER_COLOR !== 'undefined' ? LOADER_COLOR : process.env.MIX_LOADER_COLOR,
    IMG_BANNER: typeof IMG_BANNER !== 'undefined' ? IMG_BANNER : process.env.MIX_IMG_BANNER,
    AUTO_LOGIN: typeof AUTO_LOGIN !== 'undefined' ? AUTO_LOGIN : process.env.MIX_AUTO_LOGIN_ENABLE,
    LOGIN_MODE: typeof LOGIN_MODE !== 'undefined' ? LOGIN_MODE : process.env.MIX_LOGIN_MODE,
    DEMO_GIVEAWAY_ENABLE: typeof DEMO_GIVEAWAY_ENABLE !== 'undefined' ? DEMO_GIVEAWAY_ENABLE : process.env.MIX_DEMO_GIVEAWAY_ENABLE
};

export default ENV;
